/**
 * Guardia para rutas administrativas.
 *
 * Usa una bandera ligera en `localStorage` para permitir el acceso al panel
 * admin. Es un control de interfaz y no sustituye validaciones de backend.
 */
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * PrivateRouteAdmin revisa si `isAdminLogged` en localStorage está en "true".
 * Si no es así, redirige a /admin-login.
 */
const PrivateRouteAdmin = ({ component: Component, ...rest }) => {
  // Leemos la bandera desde localStorage
  const isAdminLogged = localStorage.getItem("isAdminLogged") === "true";

  // Si no está logueado como admin, lo mandamos a /admin-login
  if (!isAdminLogged) {
    return <Navigate to="/admin-login" />;
  }

  // Si está logueado, renderizamos el componente (ej. DashboardAdmin)
  return <Component {...rest} />;
};

export default PrivateRouteAdmin;
